import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { useLang } from "../contexts/LanguageContext";
import EmailTypoHint from "../components/EmailTypoHint";

export default function Login() {
  const { login } = useAuth();
  const { t } = useLang();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [checkEmail, setCheckEmail] = useState(null);
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setCheckEmail(email);
    setBusy(true);
    const r = await login(email, password);
    setBusy(false);
    if (r.ok) navigate("/");
    else setError(r.error);
  };

  return (
    <div className="mx-auto max-w-md px-6 py-20" data-testid="login-page">
      <div className="font-mono text-[10px] uppercase tracking-[0.35em] text-zinc-500 mb-4">
        {t("brand")}
      </div>
      <h1 className="font-serif text-4xl sm:text-5xl text-zinc-50 font-light tracking-tight leading-none">
        {t("login_title")}
      </h1>

      <form onSubmit={onSubmit} className="mt-10 space-y-5" data-testid="login-form">
        <div>
          <label className="font-mono text-[10px] uppercase tracking-[0.3em] text-zinc-500">
            {t("email")}
          </label>
          <input
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            onBlur={() => setCheckEmail(email)}
            className="mt-2 w-full bg-transparent border border-zinc-800 px-4 py-3 text-zinc-100 font-light focus:outline-none focus:border-zinc-500"
            data-testid="login-email-input"
          />
          {checkEmail === email && (
            <EmailTypoHint email={email} onAccept={(s) => { setEmail(s); setCheckEmail(s); }} />
          )}
        </div>
        <div>
          <label className="font-mono text-[10px] uppercase tracking-[0.3em] text-zinc-500">
            {t("password")}
          </label>
          <input
            type="password"
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="mt-2 w-full bg-transparent border border-zinc-800 px-4 py-3 text-zinc-100 font-light focus:outline-none focus:border-zinc-500"
            data-testid="login-password-input"
          />
          <div className="mt-2 text-right">
            <Link
              to="/forgot-password"
              className="font-mono text-[10px] uppercase tracking-[0.3em] text-zinc-500 hover:text-zinc-200 underline-offset-4 hover:underline"
              data-testid="login-forgot-password-link"
            >
              {t("forgot_password_link")}
            </Link>
          </div>
        </div>
        {error && (
          <div className="border border-red-900 bg-red-950/30 text-red-300 px-4 py-3 text-sm" data-testid="login-error">
            {error}
          </div>
        )}
        <button
          type="submit"
          disabled={busy}
          className="w-full bg-sienna text-white py-3 text-sm font-light hover:bg-sienna-400 disabled:opacity-60 transition-colors"
          data-testid="login-submit-button"
        >
          {busy ? t("loading") : t("sign_in")}
        </button>
      </form>

      <div className="mt-8 font-mono text-[11px] uppercase tracking-[0.25em] text-zinc-500">
        {t("no_account")}{" "}
        <Link to="/register" className="text-zinc-100 hover:text-white underline-offset-4 hover:underline" data-testid="login-to-register-link">
          {t("sign_up")}
        </Link>
      </div>
    </div>
  );
}
